<template>
  <div>
    <el-card shadow="hover">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="padding: 20px">
        <el-tab-pane label="发布项目" name="first">
          <el-form label-position="left" label-width="80px" style="text-align: left" ref="publishFormRef"
                   :model="publishForm"
                   class="publish_form">

            <el-form-item label="项目名称" prop="name">
              <el-input v-model="publishForm.name"></el-input>

            </el-form-item>
            <el-form-item label="项目类型" prop="projectCategoryId">
              <el-select v-model="publishForm.projectCategoryId">
                <el-option v-for="item in types"
                           :value="item.id"
                           :label="item.catehoryName"
                           :key="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目描述" prop="description">
              <el-input v-model="publishForm.description" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="项目图片">
              <el-upload

                ref="upload"
                name="image"
                :action="base_url+'/uploadImage'"
                list-type="picture-card"
                :limit="1"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success="handleSuccess">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>

            <el-form-item label="技术栈" prop="techs">
              <el-input v-model="publishForm.techs"></el-input>
            </el-form-item>
            <el-form-item label="项目地址" prop="path">
              <el-input v-model="publishForm.path"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center">
              <el-button type="primary" @click="publishProject">发布</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="项目列表" name="second">

          <el-table :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}" :data="projectList" border stripe>
            <el-table-column type="index"></el-table-column>
            <el-table-column label="项目名称" prop="name"></el-table-column>
            <el-table-column label="项目图片" prop="image">
              <template slot-scope="scope">
                <img :src="scope.row.image" height="60px" width="60px"
                     style="border-radius: 50%">
              </template>
            </el-table-column>
            <el-table-column label="项目类型" prop="categoryName">

            </el-table-column>
            <el-table-column label="项目地址" prop="path">
            </el-table-column>
            <el-table-column label="项目技术" prop="techs">
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <!--            删除按钮-->
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除
                </el-button>
              </template>
            </el-table-column>


          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>


<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  data() {
    return {
      id: null,
      project: {
        id: null,
        name: "",
        description: "",
        image: "",
        path: "",
        projectCategoryId: 0,
        techs: ""
      },
      base_url: base_url,
      adminInfo: null,
      projectList: [],
      dialogImageUrl: '',
      publishForm: {},
      dialogVisible: false,
      activeName: 'second',
      types: [
        {id: 1, catehoryName: '完整项目'},
        {id: 2, catehoryName: '小练习'}
      ]
    }
  },

  mounted() {
    var item = window.sessionStorage.getItem('adminInfo');
    let data = JSON.parse(item);
    this.id = data.id
    this.adminInfo = data;
    this.getProjectList()

  },
  methods: {
    //删除
    handleDelete(index, row) {
      // console.log(row)
      let that = this;
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/project/delete/' + row.id,
          method: 'post',
          params: {
            adminInfo: that.adminInfo
          }
        }).then(response => {
          if (response.data.flag) {
            this.$notify.success({
              title: '删除',
              duration: 2000,
              message: '删除成功！'
            });
            that.getProjectList();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消'
        })
      })
    },
    // 点击tab时的事件
    handleClick(tab, event) {
      if (tab.name === 'second') {
        this.getProjectList()
      }
    },
    // 删除图片
    handleRemove() {
      this.dialogImageUrl = ''
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 图片上传成功
    async handleSuccess(res) {
      this.dialogImageUrl = res.data
    },
    // 清空状态
    backPage() {
      this.$refs.upload.clearFiles()
      this.blog.firstPicture = ''
      this.$refs.publishFormRef.resetFields()
    },
    // 发布项目
    publishProject() {
      this.project.image = this.dialogImageUrl
      this.project.name = this.publishForm.name
      this.project.description = this.publishForm.description
      this.project.path = this.publishForm.path
      this.project.techs = this.publishForm.techs
      this.project.projectCategoryId = this.publishForm.projectCategoryId

      // console.log(this.project);
      request({
        url: '/project/add',
        method: 'post',
        params: {
          adminInfo: this.adminInfo,
          project: this.project
        }
      }).then(response => {
        // console.log(response.data);
        if (response.data.flag) {
          this.$notify.error({
            title: '项目',
            duration: 2000,
            message: "添加成功"
          });
        } else {
          this.$notify.error({
            title: '项目',
            duration: 2000,
            message: response.data.message
          });
        }
      })


    },
    // 获取项目列表
    getProjectList() {

      request({
        url: '/project/get',
        method: 'get',
      }).then(response => {
        // console.log(response.data);
        if (response.data.data == null) {
          return this.$message.error('获取项目列表失败！')
        }
        response.data.data.forEach(item => {
          item.image = base_url + "/getImage/" + item.image;
        })
        this.projectList = response.data.data
      })

    },
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/ProjectManager.vue